import { Component, OnDestroy } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-forget-password',
  standalone: false,
  templateUrl: './forget-password.component.html',
  styleUrl: './forget-password.component.scss',
})
export class ForgetPasswordComponent implements OnDestroy {
  email = '';
  message = '';
  loading = false;
  requestSent = false;

  resetForm = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
  });

  private destroy$ = new Subject<void>();

  constructor(
    private fb: FormBuilder,
    private auth: AuthService,
    private traslate: TranslateService
  ) {}

  requestReset() {
    if (this.resetForm.invalid) {
      this.message = this.traslate.instant('ENTER_VALID_EMAIL');
      return;
    }

    const email = this.resetForm.value.email!;
    this.loading = true;
    this.auth
      .requestPasswordReset(email)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.message = this.traslate.instant('FORGET_PASSWORD_SENT_MSG');
          this.loading = false;
          this.requestSent = true;
        },
        error: (err) => {
          this.message = this.traslate.instant(err.error);
          this.loading = false;
          this.requestSent = true;
        },
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
